import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { UndoState } from './undo.state';
import { getters } from './undo.getters';
import { mutations } from './undo.mutations';
import { actions } from './undo.actions';

VueXHelper.setStoreModule(Module.UNDO, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new UndoState(),
  getters,
  mutations,
  actions,
};
